export const parseDataFromXMLSNotifyPassenger = (
  data: Array<any>,
): Array<any> => {
  return data.map((i) => {
    return {
      id: i["__rowNum__"],
      name: i["Nombre"],
      phoneNumber: i["Telefono"],
      date: i["Fecha"],
      hour: i["Hora"],
      bookingId: i["BookingId"],
    };
  });
};

export const parseDataFromXMLSNotifyPassengerContingency = (
  data: Array<any>,
): Array<any> => {
  return data.map((i) => {
    return {
      id: i["__rowNum__"],
      hour: i["HORA"],
      client: i["CLIENTE"],
      swissOnlyApplies: i["SOLO SWISSPORT APLICA"],
      name: i["NOMBRE PAX"],
      phoneNumber: i["TELEFONO PAX"],
      originAddress: i["DESDE"],
      destinationAddress: i["HASTA"],
    };
  });
};
